import {
  Avatar,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../Typography";
import CustomTooltip from "../../CustomTooltip";
import { useSnackbar } from "../../SnackBar";
import { useTranslation } from "react-i18next";

const InviteModal = (props) => {
  const {
    openSuccess,
    handleClose,
    email,
    phonePrefix,
    phoneNumber,
    whatsappPrefix,
    whatsappNumber,
    name,
    title,
    clientName,
    clientLogo,
    successMessage,
    successMessageDescription,
  } = props;
  const snackbar = useSnackbar();
  const { t } = useTranslation("invite-modal");
  const phone = [phonePrefix, phoneNumber].filter(Boolean).join("");
  const whatsapp = [whatsappPrefix, whatsappNumber].filter(Boolean).join("");
  return (
    <Dialog
      open={openSuccess}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxWidth: "556px",
          width: "100%",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: "24px", py: "18px", borderBottom: "1px solid #EAEAEA" }}
      >
        <CustomTypography
          type="subheading"
          props={{ color: "#2F2B3DE5", lineHeight: "28px" }}
        >
          {title}
        </CustomTypography>

        <IconButton onClick={handleClose} size="small">
          <CloseIcon fontSize="small" sx={{ color: "rgba(62, 63, 76, 1)" }} />
        </IconButton>
      </Box>

      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "32px" }}>
          <Box>
            <CustomTypography
              type="subheading"
              props={{ color: "#2F2B3DE5", lineHeight: "28px" }}
            >
              {successMessage}
            </CustomTypography>

            {successMessageDescription ? (
              <CustomTypography
                type="subheading"
                props={{
                  color: "#2F2B3DE5",
                  lineHeight: "160%",
                  fontWeight: 400,
                  mt: "16px",
                }}
              >
                {successMessageDescription}
              </CustomTypography>
            ) : (
              <></>
            )}
          </Box>

          {clientName || clientLogo ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Avatar src={clientLogo} sx={{ width: "38px", height: "38px" }} />
              <Typography
                sx={{ fontSize: "14px", fontWeight: 600, lineHeight: "20px" }}
              >
                {clientName}
              </Typography>
            </Box>
          ) : (
            <></>
          )}

          {email || phone || whatsapp ? (
            <Box
              sx={{
                display: "inline-flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              {email ? (
                <CustomTooltip
                  title={t("tooltips.copy_email")}
                  placement="bottom"
                >
                  <Box
                    sx={{
                      display: "flex",
                      cursor: "pointer",
                      gap: "8px",
                      maxWidth: "max-content",
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText(email);
                      snackbar(t("messages.email_copied", { name }), "success");
                    }}
                  >
                    <img src="/mail_icon.svg" alt="email" />
                    <CustomTypography
                      type="subheading"
                      props={{
                        color: "#3E3F4C",
                        lineHeight: "160%",
                        fontWeight: 400,
                        textDecoration: "underline",
                        wordBreak: "break-word",
                      }}
                    >
                      {email}
                    </CustomTypography>
                  </Box>
                </CustomTooltip>
              ) : null}

              {phone ? (
                <CustomTooltip
                  title={t("tooltips.copy_phone")}
                  placement="bottom"
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "max-content",
                      cursor: "pointer",
                      gap: "8px",
                    }}
                    onClick={() => {
                      navigator.clipboard.writeText(phone);
                      snackbar(t("messages.phone_copied", { name }), "success");
                    }}
                  >
                    <img src="/phone_icon.svg" alt="phone" />
                    <CustomTypography
                      type="subheading"
                      props={{
                        color: "#3E3F4C",
                        lineHeight: "160%",
                        fontWeight: 400,
                        textDecoration: "underline",
                      }}
                    >
                      <span dir="ltr">{phone}</span>
                    </CustomTypography>
                  </Box>
                </CustomTooltip>
              ) : null}

              {whatsapp ? (
                <CustomTooltip
                  title={t("tooltips.open_whatsapp")}
                  placement="bottom"
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "max-content",
                      cursor: "pointer",
                      gap: "8px",
                    }}
                    onClick={() => window.open(`https://wa.me/${whatsapp}`)}
                  >
                    <img src="/whatsapp_icon.svg" alt="whatsapp" />
                    <CustomTypography
                      type="subheading"
                      props={{
                        color: "#3E3F4C",
                        lineHeight: "160%",
                        fontWeight: 400,
                        textDecoration: "underline",
                      }}
                    >
                      <span dir="ltr">{whatsapp}</span>
                    </CustomTypography>
                  </Box>
                </CustomTooltip>
              ) : null}
            </Box>
          ) : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default InviteModal;
